/*
 * Teams as a context. The front-end manifest, see lib/docs/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'teams',
	locale: { de, en },
	// The settings of one team, see pages/Context/ContextSettings.vue; the app spreads extensionRoutes()
	routes: [
		{
			path: 'teams/:id/settings',
			name: 'teams.settings',
			component: () => import('@lib/pages/Context/ContextSettings.vue'),
			props: (route) => ({ context: 'team', id: route.params.id }),
		},
	],
});
